<template>
	<button v-tooltip="{ content: lang.toggleSearch}" :class="{selected: isOpen}" class="btn filter-drawer-toggle-button" v-bind="config.attrs" @click="toggleFilters" v-html="caption">
		<config-style-injector
				:config="config"
				:root-selector="`.filter-drawer-toggle-button`"
		/>
	</button>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import featureMixin from "@/mixins/featureMixin";
// import { appDict } from "@/features/FeatureHelper";
// import Lytics from "@/classes/Lytics";
//import FilterPanel from "@/features/filters/FilterPanel.vue";
import ConfigStyleInjector from "@/components/style-injector/ConfigStyleInjector.vue";

export default {
	name: "FilterDrawerToggleButton",
	components: {ConfigStyleInjector},
	mixins: [featureMixin],
	data() {
		return {
			featurePath: 'filterToggleButton',
			drawer: 'header'
		}
	},
	watch: {
 
},
	computed: {
		...mapState('drawer', ['drawerItems']),
		...mapGetters('filters', ["isFilterPanelOpen"]),
		...mapGetters(['isCTC']),
		...mapGetters('search', ['showSearchResults', 'filteredItems', 'filteredItemsIntersection']),

		isOpen() {
			return this.isFilterPanelOpen;
		},
		caption() {
			return this.config.label || 'Search'
		}
	},
	methods: {
		...mapActions('filters', ["setFilterPanelState",'clearFilters']),
		...mapActions('inlineDrawers', ['openFilter','openFilterSortWindow','setFilterSortWindowOpen']),
		  ...mapActions('drawer', ['openSingleInDrawer','addToDrawer','removeFromDrawer']),
		  toggleFilters() {

		//  CTC behavior (existing)
			 if (this.isCTC) {
				
				this.setFilterSortWindowOpen(!this.isFilterSortWindowOpen);	
				
			 }
		// non-CTC behavior (existing)
			else this.setFilterPanelState(!this.isOpen);
		},
		
	},
	beforeDestroy() {
		this.setFilterPanelState(false);
		if (this.isCTC) {
			
			this.$store.dispatch('inlineDrawers/closeAll', null, { root: true });
			this.$store.dispatch(
			'drawer/removeFromDrawer',
			{ id: 'filterSortSelector', drawer: 'top' },
			{ root: true }
			);
		}
		//this.removeFromDrawer( {id: 'filters', drawer: this.drawer});
	}
}
</script>

<style lang="scss" scoped>

button.filter-drawer-toggle-button {
	background: var(--button-background);
	color: #5e92eb ;
	margin-right: auto;

	&.selected {
		background: #F2F2F2 !important;
		color:  var(--secondary-color) !important;
		filter: unset !important;
		svg 
		g {
			g {
				path {
					color: #545454;
				}
			}
		}
	}
}



</style>
